var _path, _g, _g2, _path2, _circle, _path3, _g3, _circle2, _path4, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTeradataTestimonialBackground = function SvgTeradataTestimonialBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 598,
    viewBox: "0 0 1440 598",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M317.773 443.618C106.201 468.365 -131.161 361.079 -224.954 294.936L-189.616 597.06L1704.48 375.516L1682.62 188.684C1190.89 -21.1015 609.33 409.516 317.773 443.618Z",
    fill: "url(#TeradataTestimonialBackground_svg__paint0_linear_325_14337)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1012.25,
    cy: 144.322,
    r: 8.61023,
    fill: "#51A9E3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1363.75,
    cy: 57.2066,
    r: 5.57133,
    fill: "#51A9E3"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 1260.93,
    cy: 143.815,
    r: 5.06484,
    fill: "#51A9E3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1188,
    cy: 190.412,
    r: 3.0389,
    fill: "#51A9E3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1323.73,
    cy: 210.671,
    r: 3.0389,
    fill: "#51A9E3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1146.97,
    cy: 60.2456,
    r: 8.61023,
    stroke: "#51A9E3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 958.558,
    cy: 6.55836,
    r: 4.55836,
    stroke: "#51A9E3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1419.87 10.1418L1420.03 26.4746L1434.02 18.2944L1419.87 10.1418Z",
    fill: "#51A9E3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1026.24 98.0604L1016.8 102.92L1025.63 108.655L1026.24 98.0604Z",
    fill: "#51A9E3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1057.64 6.8933L1048.21 11.7526L1057.04 17.4874L1057.64 6.8933Z",
    fill: "#51A9E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.09 261.155L1003.64 271.175L1021.84 283L1023.09 261.155Z",
    stroke: "#51A9E3",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1389.62 170.217L1388.26 189.27L1405.35 181.061L1389.62 170.217Z",
    stroke: "#51A9E3",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 706.444,
    cy: 432.403,
    r: 5.67826,
    fill: "#51A9E3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 750.734,
    cy: 273.412,
    r: 4.5426,
    fill: "#51A9E3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 339.629,
    cy: 426.725,
    r: 5.67826,
    fill: "#51A9E3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.49,
    cy: 493.729,
    r: 2.2713,
    fill: "#51A9E3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 614.456,
    cy: 339.28,
    r: 6.81391,
    fill: "#51A9E3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373.699,
    cy: 481.237,
    r: 7.94956,
    stroke: "#51A9E3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.317 308.534L488.536 324.356L497.629 308.625L479.317 308.534Z",
    fill: "#51A9E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.989 472.964L161.335 479.479L161.363 466.497L149.989 472.964Z",
    fill: "#51A9E3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M564.093 271.811L547.665 281.017L563.684 290.638L564.093 271.811Z",
    fill: "#51A9E3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M590.825 439.116L595.256 463.243L613.861 447.548L590.825 439.116Z",
    stroke: "#51A9E3",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.6783,
    cy: 63.5966,
    r: 5.67826,
    transform: "rotate(180 51.6783 63.5966)",
    fill: "#51A9E3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418.493,
    cy: 69.2746,
    r: 5.67826,
    transform: "rotate(180 418.493 69.2746)",
    fill: "#51A9E3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 486.632,
    cy: 2.2713,
    r: 2.2713,
    transform: "rotate(180 486.632 2.2713)",
    fill: "#51A9E3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.666,
    cy: 156.72,
    r: 6.81391,
    transform: "rotate(180 143.666 156.72)",
    fill: "#51A9E3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384.423,
    cy: 14.7635,
    r: 7.94956,
    transform: "rotate(180 384.423 14.7635)",
    stroke: "#51A9E3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 788.147,
    cy: 65.3001,
    r: 3.97478,
    transform: "rotate(180 788.147 65.3001)",
    stroke: "#51A9E3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.805 187.466L269.586 171.644L260.493 187.375L278.805 187.466Z",
    fill: "#51A9E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.133 23.036L596.787 16.5207L596.759 29.5028L608.133 23.036Z",
    fill: "#51A9E3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M194.029 224.189L210.457 214.983L194.438 205.362L194.029 224.189Z",
    fill: "#51A9E3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M167.297 56.8842L162.866 32.7571L144.261 48.4523L167.297 56.8842Z",
    stroke: "#51A9E3",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1308.79,
    cy: 349.941,
    r: 3.20588,
    fill: "#51A9E3"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 1168.8,
    cy: 497.411,
    r: 9.61763,
    stroke: "#51A9E3",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1270.32,
    cy: 282.617,
    r: 6.41175,
    fill: "#51A9E3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1162.39,
    cy: 170.412,
    r: 6.41175,
    fill: "#51A9E3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1101.48,
    cy: 311.47,
    r: 7.48038,
    stroke: "#51A9E3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1290.01 399.341L1301.52 412.161L1306.9 395.931L1290.01 399.341Z",
    fill: "#51A9E3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#TeradataTestimonialBackground_svg__filter0_d_325_14337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-225 294.544C-131.207 360.687 106.155 467.973 317.727 443.226C609.284 409.124 1190.84 -21.4931 1682.58 188.292",
    stroke: "url(#TeradataTestimonialBackground_svg__paint1_linear_325_14337)",
    strokeWidth: 4
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-225 294.544C-131.207 360.687 106.155 467.973 317.727 443.226C609.284 409.124 1190.84 -21.4931 1682.58 188.292",
    stroke: "url(#TeradataTestimonialBackground_svg__paint2_linear_325_14337)",
    strokeWidth: 2,
    strokeDasharray: "0.01 6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 429,
    r: 24,
    fill: "#51A9E3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "TeradataTestimonialBackground_svg__mask0_325_14337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 416,
    width: 25,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M121 416H96.9999V440H121V416Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#TeradataTestimonialBackground_svg__mask0_325_14337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.682 429.378C118.581 429.385 118.488 429.414 118.409 429.457C118.287 429.478 118.158 429.5 118.007 429.5H113.507C113.256 429.5 112.007 429.428 112.007 428H119.507C119.507 428.201 119.457 429.055 118.689 429.378H118.682ZM118 434.007H111.584C111.311 434.007 111.067 434.151 110.93 434.388C110.636 434.904 110.155 435.27 109.588 435.435C109.014 435.593 108.411 435.514 107.895 435.22C107.55 435.026 107.263 434.732 107.062 434.388C106.926 434.151 106.682 434.007 106.409 434.007H99.9999V425.754C99.9999 424.512 101.012 423.5 102.253 423.5H110.507V428C110.507 430.203 112.301 431 113.507 431H118.007V434L118 434.007ZM119.5 436.261C119.5 437.502 118.488 438.514 117.253 438.514H100.753C99.5118 438.514 98.4999 437.502 98.4999 436.261V435.507H106.014C106.316 435.916 106.71 436.261 107.155 436.519C108.024 437.014 109.029 437.136 109.983 436.878C110.801 436.656 111.497 436.175 111.993 435.507H119.5V436.261ZM113.5 417.5H118C118.251 417.5 119.5 417.572 119.5 419H112C112 418.749 112.072 417.5 113.5 417.5ZM112 420.5H119.5V426.5H112V420.5ZM118 416H113.5C111.304 416 110.5 417.794 110.5 419V422H102.253C100.186 422 98.4999 423.679 98.4999 425.754V434.007H97.7463C97.33 434.007 96.9927 434.344 96.9927 434.761V436.261C96.9927 438.335 98.6721 440.014 100.746 440.014H117.246C119.313 440.014 120.993 438.335 120.993 436.261V434.761C120.993 434.344 120.655 434.007 120.246 434.007H119.493V430.648C120.569 430.06 120.993 428.883 120.993 428V419C121 416.804 119.206 416 118 416Z",
    fill: "white"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1336,
    cy: 134,
    r: 24,
    fill: "#F22F46"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "TeradataTestimonialBackground_svg__mask1_325_14337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1324,
    y: 120,
    width: 24,
    height: 24
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1348 120H1324V144H1348V120Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#TeradataTestimonialBackground_svg__mask1_325_14337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1342.75 136.428C1342.75 137.225 1342.32 137.978 1341.63 138.38C1338.15 140.383 1333.85 140.383 1330.37 138.38C1329.68 137.978 1329.25 137.232 1329.25 136.428V135H1342.75V136.428H1342.75ZM1329.25 131.254C1329.25 127.536 1332.28 124.5 1336.01 124.5C1339.73 124.5 1342.76 127.529 1342.76 131.254V133.507H1329.25V131.254ZM1346.51 139.644V135.754C1346.51 134.512 1345.5 133.5 1344.25 133.5V131.246C1344.25 126.955 1340.95 123.416 1336.75 123.036V120.754C1336.75 120.337 1336.42 120 1336 120C1335.58 120 1335.25 120.337 1335.25 120.754V123.043C1331.05 123.423 1327.75 126.962 1327.75 131.254V133.507C1326.5 133.507 1325.49 134.519 1325.49 135.761V139.651C1324.63 139.952 1324 140.778 1324 141.754V143.254C1324 143.67 1324.34 144.007 1324.75 144.007C1325.17 144.007 1325.51 143.67 1325.51 143.254V141.754C1325.51 141.337 1325.84 141 1326.26 141C1326.68 141 1327.01 141.337 1327.01 141.754V143.254C1327.01 143.67 1327.35 144.007 1327.77 144.007C1328.18 144.007 1328.52 143.67 1328.52 143.254V141.754C1328.52 140.778 1327.89 139.952 1327.02 139.644V135.754C1327.02 135.337 1327.36 135 1327.78 135V136.428C1327.78 137.763 1328.49 139.005 1329.65 139.679C1331.61 140.813 1333.82 141.38 1336.02 141.38C1338.22 141.38 1340.43 140.813 1342.39 139.679C1343.55 139.012 1344.27 137.763 1344.27 136.428V135C1344.68 135 1345.02 135.337 1345.02 135.754V139.644C1344.15 139.952 1343.52 140.778 1343.52 141.754V143.254C1343.52 143.67 1343.86 144.007 1344.28 144.007C1344.69 144.007 1345.03 143.67 1345.03 143.254V141.754C1345.03 141.337 1345.37 141 1345.78 141C1346.2 141 1346.54 141.337 1346.54 141.754V143.254C1346.54 143.67 1346.87 144.007 1347.28 144.007C1347.69 144.007 1348.03 143.67 1348.03 143.254V141.754C1348.03 140.778 1347.4 139.952 1346.53 139.644",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1333 128.254C1332.58 128.254 1332.25 128.591 1332.25 129.007V130.507C1332.25 130.923 1332.58 131.261 1333 131.261C1333.42 131.261 1333.75 130.923 1333.75 130.507V129.007C1333.75 128.591 1333.41 128.254 1333 128.254Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339 128.254C1338.58 128.254 1338.25 128.591 1338.25 129.007V130.507C1338.25 130.923 1338.58 131.261 1339 131.261C1339.42 131.261 1339.75 130.923 1339.75 130.507V129.007C1339.75 128.591 1339.41 128.254 1339 128.254Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "TeradataTestimonialBackground_svg__filter0_d_325_14337",
    x: -256.153,
    y: 98.9325,
    width: 1969.52,
    height: 379.93,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.415686 0 0 0 0 0.866667 0 0 0 0 0.698039 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_325_14337"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_325_14337",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "TeradataTestimonialBackground_svg__paint0_linear_325_14337",
    x1: 838.675,
    y1: 3.31429,
    x2: 876.57,
    y2: 417.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F304C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121C2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "TeradataTestimonialBackground_svg__paint1_linear_325_14337",
    x1: -403.875,
    y1: 422.147,
    x2: 1692.33,
    y2: 176.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.055,
    stopColor: "#121C2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    stopColor: "#6ADDB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#121C2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "TeradataTestimonialBackground_svg__paint2_linear_325_14337",
    x1: -212.76,
    y1: 399.194,
    x2: 1681.33,
    y2: 177.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#121C2D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121C2D",
    stopOpacity: 0
  })))));
};
export default SvgTeradataTestimonialBackground;